import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { createSettlementNote_providerFormZodObject } from "../create-settlement-note.provider-form";

const createSettlementNoteCommandZodObject = z.object({
    _id: z.string(),
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("CREATE_SETTLEMENT_NOTE_COMMAND"),
    triggerPdfCreation: z.boolean(),
    requestedBy: userIdZodSchema,
    form: createSettlementNote_providerFormZodObject,
});
type CreateSettlementNoteCommand = z.infer<
    typeof createSettlementNoteCommandZodObject
>;

type FactoryParams = Except<
    CreateSettlementNoteCommand,
    "_id" | "_type" | "_createdAt"
>;
const createSettlementNoteCommandFactory = (params: FactoryParams) => {
    const CreateSettlementNoteCommand: CreateSettlementNoteCommand = {
        ...params,
        _id: generateId({ prefix: "create_settlement_note_command__" }),
        _type: "CREATE_SETTLEMENT_NOTE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return CreateSettlementNoteCommand;
};

export {
    createSettlementNoteCommandFactory,
    createSettlementNoteCommandZodObject,
};
export type { CreateSettlementNoteCommand };
